// (() => {
//   const html = document.documentElement;
//   const loader = document.getElementById("loader");
//   const site = document.getElementById("site");
//   const bar = loader?.querySelector(".loader__bar-fill");

//   html.classList.add("is-loading");

//   const imgs = Array.from(document.images || []);
//   const total = Math.max(imgs.length, 1);
//   let loaded = 0;

//   const updateProgress = () => {
//     loaded = Math.min(loaded + 1, total);
//     const pct = Math.round((loaded / total) * 100);
//     if (bar) bar.style.width = pct + "%";
//   };

//   imgs.forEach((img) => {
//     if (img.complete) updateProgress();
//     else {
//       img.addEventListener("load", updateProgress, { once: true });
//       img.addEventListener("error", updateProgress, { once: true });
//     }
//   });

//   // const MIN_SHOW = 2500; // ←★★ 表示時間を長くしたいならここを増やす（ms）
//   const MIN_SHOW = 3500; // ←★★ 表示時間を長くしたいならここを増やす（ms）

//   const startAt = performance.now();
//   const HARD_TIMEOUT = 7000;
//   const hardTimer = setTimeout(() => done("timeout"), HARD_TIMEOUT);

//   window.addEventListener("load", () => {
//     const elapsed = performance.now() - startAt;
//     const remain = Math.max(0, MIN_SHOW - elapsed);
//     setTimeout(() => done("window-load"), remain);
//   });

//   function done(reason) {
//     clearTimeout(hardTimer);
//     if (bar) bar.style.width = "100%";
//     site?.classList.add("is-ready");
//     html.classList.remove("is-loading");

//     // ★ ここでスライドアウト用クラスを付けてトランジションを発火
//     loader?.classList.add("is-slideout");

//     /*
//     nishida
//     cssで記載されていたloadingを上に移動するtransformを波分の高さを足すために
//     JSで設定することに変更する
//     */
//     const loadh = $(".loader").height();//loaderの高さ取得
//     const waveh2 = $(".loader svg").height();//波の高さ取得
//     const tmpheight = loadh + waveh2;//高さを合わせて
//     const translateY = 'translateY(-' + tmpheight + 'px)';//プロパティ定義
//     $("#loader.is-slideout").css("transform", translateY);//実行

//     // ★ CSSのtransition時間と合わせて遅延削除
//     setTimeout(() => loader?.remove(), 2000); // ← ここはCSSのdurationと同じに
//   }
// })();

// /* 波の位置設定 */
// $(document).ready(function () {
//   const waveh = $(".loader svg").height();
//   $(".loader svg").css("bottom", -waveh);
// });

/* 1212 調整 */

(() => {
  // =========================
  // 7日間省略機能
  // =========================
  const STORAGE_KEY = "miiplus_loading_shown";
  const DISPLAY_INTERVAL_DAYS = 7;
  const ONE_WEEK_MS = DISPLAY_INTERVAL_DAYS * 24 * 60 * 60 * 1000;

  const shouldShowLoading = () => {
    try {
      const lastShown = localStorage.getItem(STORAGE_KEY);
      if (!lastShown) return true;
      const lastShownTime = parseInt(lastShown, 10);
      if (isNaN(lastShownTime)) return true;
      return Date.now() - lastShownTime >= ONE_WEEK_MS;
    } catch (e) {
      console.warn("localStorage is not available:", e);
      return true;
    }
  };

  const html = document.documentElement;
  const body = document.body;
  const loader = document.getElementById("loader");
  const site = document.getElementById("site");
  const bar = loader?.querySelector(".loader__bar-fill");

  // loaderがない場合は即座に終了
  if (!loader) {
    site?.classList.add("is-ready");
    html.classList.remove("is-loading");
    return;
  }

  // 7日以内に表示済みならスキップ
  if (!shouldShowLoading()) {
    loader.remove();
    site?.classList.add("is-ready");
    html.classList.remove("is-loading");
    window.dispatchEvent(new CustomEvent("loadingComplete"));
    return;
  }

  // 表示するのでlocalStorageに記録
  try {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
  } catch (e) {
    console.warn("Failed to save to localStorage:", e);
  }

  // =========================
  // ローディング中スクロール禁止
  // =========================
  let scrollY = 0;
  const preventTouch = (e) => e.preventDefault();

  function lockScroll() {
    scrollY = window.scrollY || window.pageYOffset || 0;

    // bodyを固定してスクロール停止（位置ズレ防止）
    body.style.position = "fixed";
    body.style.top = `-${scrollY}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";

    // iOSなどのゴムスク対策
    document.addEventListener("touchmove", preventTouch, { passive: false });
  }

  function unlockScroll() {
    document.removeEventListener("touchmove", preventTouch);

    body.style.position = "";
    body.style.top = "";
    body.style.left = "";
    body.style.right = "";
    body.style.width = "";

    // ハッシュがある場合はその要素にスクロール、なければ元の位置に戻す
    const hash = window.location.hash;
    if (hash) {
      const target = document.querySelector(hash);
      if (target) {
        target.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, scrollY);
  }

  // ローディング開始時にロック
  html.classList.add("is-loading");
  lockScroll();

  const imgs = Array.from(document.images || []);
  const total = Math.max(imgs.length, 1);
  let loaded = 0;

  const updateProgress = () => {
    loaded = Math.min(loaded + 1, total);
    const pct = Math.round((loaded / total) * 100);
    if (bar) bar.style.width = pct + "%";
  };

  imgs.forEach((img) => {
    if (img.complete) updateProgress();
    else {
      img.addEventListener("load", updateProgress, { once: true });
      img.addEventListener("error", updateProgress, { once: true });
    }
  });

  const MIN_SHOW = 3500;
  const startAt = performance.now();
  const HARD_TIMEOUT = 7000;
  const hardTimer = setTimeout(() => done("timeout"), HARD_TIMEOUT);

  window.addEventListener("load", () => {
    const elapsed = performance.now() - startAt;
    const remain = Math.max(0, MIN_SHOW - elapsed);
    setTimeout(() => done("window-load"), remain);
  });

  function done(reason) {
    clearTimeout(hardTimer);
    if (bar) bar.style.width = "100%";
    site?.classList.add("is-ready");
    html.classList.remove("is-loading");

    unlockScroll();

    let lastWidth = null;
    let stableCount = 0;
    const startTime = performance.now();
    const POLL_INTERVAL = 50;
    const STABLE_THRESHOLD = 2;
    const MAX_WAIT = 1000;

    const checkStability = () => {
      const slideLink = document.querySelector(".swiper-slide .slide-link");
      const currentWidth = slideLink
        ? slideLink.getBoundingClientRect().width
        : 0;
      const elapsed = Math.round(performance.now() - startTime);

      console.log(
        `[Loading] Stability check at ${elapsed}ms: width=${currentWidth}px`,
      );

      if (currentWidth === lastWidth && currentWidth > 0) {
        stableCount++;
        if (stableCount >= STABLE_THRESHOLD) {
          window.dispatchEvent(new CustomEvent("loadingComplete"));
          console.log(
            `[Loading] ✅ Width stabilized at ${currentWidth}px after ${elapsed}ms`,
          );
          return;
        }
      } else {
        stableCount = 0;
      }

      lastWidth = currentWidth;

      if (elapsed < MAX_WAIT) {
        setTimeout(checkStability, POLL_INTERVAL);
      } else {
        window.dispatchEvent(new CustomEvent("loadingComplete"));
        console.log(
          `[Loading] ⚠️ Timeout after ${elapsed}ms, using width=${currentWidth}px`,
        );
      }
    };

    checkStability();

    // ★ ここでスライドアウト用クラスを付けてトランジションを発火
    loader?.classList.add("is-slideout");

    /*
      nishida
      cssで記載されていたloadingを上に移動するtransformを波分の高さを足すために
      JSで設定することに変更する
    */
    const loadh = $(".loader").height();
    const waveh2 = $(".loader svg").height();
    const tmpheight = loadh + waveh2;
    const translateY = "translateY(-" + tmpheight + "px)";
    $("#loader.is-slideout").css("transform", translateY);

    // ★ CSSのtransition時間と合わせて遅延削除
    setTimeout(() => loader?.remove(), 2000);
  }
})();

/* 波の位置設定 */
$(document).ready(function () {
  const waveh = $(".loader svg").height();
  $(".loader svg").css("bottom", -waveh);
});
